// Module
var code = `
<div class="order-edit-parameter-sector" style="{{^dp.allowedSL}}display:none;{{/}}">
    <terceraLabel text="{{slLabel}}"
                  additionalClass="{{additionalClassName}}"
                  visible="{{dp.allowedSL}}" />

    <terceraSLTPNumeric isSL="true"
                        Intervals="{{dp.trailingStop.enabled ? null : dp.sl.Intervals}}"
                        value="{{slValue}}"
                        minValue="{{slMin}}"
                        maxValue="{{slMax}}"
                        step="{{slStep}}"
                        tooltip="{{slTooltip}}"
                        decimalPrecision="{{slPrecision}}"
                        customError="{{slCustomError}}"
                        SLTPChecked="{{dp.sl.enabled}}"
                        canEdit="{{dp.sl.canEdit}}"
                        trStopVisible="{{dp.trailingStopAllowed}}"
                        trStopChecked="{{dp.trailingStop.enabled}}"
                        visible="{{dp.allowedSL}}"
                        rightAlignedText="{{slNumericRightAlignedText}}"
                        rightAlignedTextAdditionalClass="watermark"
                        name="SLNumeric"
                        instrument="{{instrument}}"
                        isVisibleEnableButton="{{dp.isVisibleEnableButtonSL}}"/>

</div>


{{#dp.allowedSL}}
<div class="order-edit-parameter-sector" style="{{^sllVisible}}display:none;{{/}}">
    <terceraLabel text="{{sllLabel}}"
                  visible="{{sllVisible}}"
                  additionalClass="{{additionalClassName}}" />

    <terceraNumeric tradingNumeric="true"
                    tooltip="{{sllLabelTooltip}}"
                    enabled="{{!dp.trailingStop.enabled}}"
                    visible="{{sllVisible}}"
                    Intervals="{{dp.sl.Intervals}}"
                    value="{{sllValue}}"
                    minValue="{{sllMin}}"
                    maxValue="{{sllMax}}"
                    decimalPrecision="{{sllPrecision}}"
                    step="{{sllStep}}"
                    name="sllNumeric" />
</div>

<div class="order-edit-parameter-sector" style="{{^dp.sl.enabled}}display:none;{{/}}">
    <terceraLabel text="{{slLabelOffset}}"
                  additionalClass="{{additionalClassName}}"
                  visible="{{dp.sl.enabled}}" />

    <div class="pnlBlockSL">
        <terceraLabel text="{{dp.slProfit}}"
                      visible="{{dp.sl.enabled}}"
                      additionalClass="{{dp.slProfitValue > 0 ? 'upclass' : 'downclass'}}" />

        <terceraLabel text="{{dp.slLabel}}"
                      visible="{{dp.sl.enabled}}"
                      additionalClass="value" />
    </div>
</div>

<div class="order-edit-parameter-sector" style="{{dp.SLTriggerVisible && dp.SLTriggerVisible() ? '' : 'display:none;'}}">
    <sltpTriggerControl name="SLTrigger"
                        isForSL="true"
                        isForOE="true"
                        side="{{side}}"
                        dynProperty="{{dp}}"
                        value="{{sltpTriggerShortValue}}"
                        triggersVisible="{{dp.SLTriggerVisible && dp.SLTriggerVisible()}}" />
</div>

{{#if dp.sl.enabled && dp.isVisibleOTHTrading}}
    <overnightExecutionControlRactive isEnabled="{{dp.isEnabledOTHTradingSL}}" 
                                    isActive="{{dp.isAllowOTHTradingSL}}" 
                                    textKey="{{overnightExecutionTextKey}}" 
                                    tooltipKey="{{dp.isAllowOTHTradingSL ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                    controlWidth="200" 
                                    events="{{isAllowOTHTradingSLEvents}}"/>
{{/if}}

{{/}}

<div class="order-edit-parameter-sector" style="{{^dp.allowedTP}}display:none;{{/}}">
    <terceraLabel text="{{tpLabel}}"
                  visible="{{dp.allowedTP}}" />

    {{#with dp.tp}}
    <terceraSLTPNumeric isSL="false"
                        Intervals="{{dp.tp.Intervals}}"
                        value="{{value}}"
                        minValue="{{minimalValue}}"
                        maxValue="{{maximalValue}}"
                        step="{{increment}}"
                        tooltip="{{tpTooltip}}"
                        decimalPrecision="{{decimalPlaces}}"
                        customError="{{error}}"
                        SLTPChecked="{{enabled}}"
                        visible="{{dp.allowedTP}}"
                        rightAlignedText="{{tpNumericRightAlignedText}}"
                        rightAlignedTextAdditionalClass="watermark"
                        name="TPNumeric" 
                        instrument="{{instrument}}" />
    {{/with}}
</div>

{{#dp.allowedTP}}
<div class="order-edit-parameter-sector" style="{{^dp.tp.enabled}}display:none;{{/}}">
    <terceraLabel text="{{tpLabelOffset}}"
                  visible="{{dp.tp.enabled}}" />

    <div class="pnlBlockTp">
        <terceraLabel text="{{dp.tpProfit}}"
                      additionalClass="{{dp.tpProfitValue > 0 ? 'upclass' : 'downclass'}}"
                      visible="{{dp.tp.enabled}}" />

        {{#with dp.tp}}
        <terceraLabel text="{{dp.tpLabel}}"
                      visible="{{dp.tp.enabled}}"
                      additionalClass="value" />
        {{/with}}
    </div>
</div>

<div class="order-edit-parameter-sector" style="{{dp.TPTriggerVisible && dp.TPTriggerVisible() ? '' : 'display:none;'}}">
    <sltpTriggerControl name="TPTrigger"
                        isForSL="false"
                        isForOE="true"
                        side="{{side}}"
                        dynProperty="{{dp}}"
                        value="{{sltpTriggerShortValue}}"
                        triggersVisible="{{dp.TPTriggerVisible && dp.TPTriggerVisible()}}" />
</div>

{{#dp.tp.enabled && dp.isVisibleOTHTrading}}
    <overnightExecutionControlRactive isEnabled="{{dp.isEnabledOTHTradingTP}}" 
                                    isActive="{{dp.isAllowOTHTradingTP}}" 
                                    textKey="{{overnightExecutionTextKey}}" 
                                    tooltipKey="{{dp.isAllowOTHTradingTP ? overnightExecutionTooltipKeyActive : overnightExecutionTooltipKeyInActive}}" 
                                    controlWidth="200" 
                                    events="{{isAllowOTHTradingTPEvents}}"/>
{{/}}

{{/}}`;
// Exports
export default code;